import React from 'react';
import {observer} from 'mobx-react';
import {FormLayout, Input, Panel} from 'components';
import {t} from 'shared/core';

const CostCoverageForm = observer(({uiState}) => {
  const {currentCoverage, errors} = uiState;

  return (
    <div>
      <Panel.Separator />
      <Panel.Subheader title={t('taxable_benefits.Premiums')}/>
      <FormLayout>
        <Input value={currentCoverage.cost}
          onChange={e => currentCoverage.merge({cost: e.target.value})}
          label='taxable_benefits.Premium'
          errorMessage={errors.cost}
        />
        {currentCoverage.isDependentLife &&
          <Input value={currentCoverage.singleParentCost}
            onChange={e => currentCoverage.merge({singleParentCost: e.target.value})}
            label='taxable_benefits.Child Only Premium'
            helpMessage='taxable_benefits.help_text.child_only'
            errorMessage={errors.singleParentCoveragePremium}
          />}
      </FormLayout>
    </div>
  );
});

export default CostCoverageForm;

